<template>
    <div class="wrap">
        <div class="title">
            <div class="title_left">晨检</div>
        </div>
        <div v-if="true" class="innerBox">
			<ErrorTemplate></ErrorTemplate>
		</div>
        <div v-if="false" class="innerBox">
            <div class="filtrate">
                <el-input placeholder="被检查人姓名,问题项,检查人姓名" class="w250 seekIpt mr20" v-model="queryLimit. keyword">
                    <i slot="suffix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-date-picker
                        class="mr20"
                        v-model="queryLimit.searchMonth"
                        type="month"
                        placeholder="检查时间">
                </el-date-picker>
                <el-select v-model="healthProblem" class="mr20" placeholder="选择健康问题">
                    <el-option v-for="item in health" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-model="hygieneProblem" class="mr20" placeholder="选择卫生问题">
                    <el-option v-for="item in hygiene" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-button>重置</el-button>
            </div>
            <div class="operate clear_a">
                <div class="left mt20">
                    <el-button class="selectHeight mr20" type="primary" @click="dialogChecked = true">
                        <i style="margin-right: 5px;font-weight: 700;color: #fff;" class="el-icon-plus"></i>新增
                    </el-button>
                    <el-button class="mr20">批量删除</el-button>
                </div>
                <div class="right mt20">
                    <el-button type="primary">导出</el-button>
                </div>
            </div>
            <el-divider></el-divider>
            <div class="content">
                <div class="tabOffTop120">
                    <!-- v-loading="loading" element-loading-text="数据正在努力加载中"  -->
                    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                              @selection-change="handleSelectionChange">
                        <el-table-column type="selection" width="55">
                        </el-table-column>
                        <el-table-column label="检查时间" width="180" sortable>
                            <template slot-scope="scope">{{ scope.row.date }}</template>
                        </el-table-column>
                        <el-table-column prop="name" label="健康问题" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="address" label="卫生问题" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="inspector" label="检查人" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="remark" label="备注" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column label="操作" min-width="150">
                            <template slot-scope="scope">
                                <a href="javascript:;" class="operate-a">编辑</a>
                                <router-link to="/inspect/detail">
                                    <a href="javascript:;" class="operate-a">查看详情</a>
                                </router-link>
                                <a href="javascript:;" class="operate-a" @click="delData">删除</a>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
                <ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange"
                              style="margin-top:10px;">
                </ybPagination>
            </div>
        </div>

        <el-dialog
                title="选择被检查人"
                :visible.sync="dialogChecked"
                width="720px"
                height="512px"
                :before-close="handleClose">
            <div class="module clear_a">
                <div class="line"></div>
                <div class="header clear_a">
                    <div class="left_header">
                        <el-input placeholder="被检查人姓名" class="w250 seekIpt mr20" v-model="searchWd.keyword">
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
                        </el-input>
                    </div>
                    <div class="right_header clear_a">
                        <span class="title">{{title}}</span>
                        <span class="statistic">共{{checkedCities.length}}{{unit}}</span>
                    </div>
                </div>
                <div class="left_module" v-if="cities.length >0 && dataNull === false">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
                    </el-checkbox>
                    <div style="margin: 15px 0;"></div>
                    <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                        <el-checkbox v-for="item in cities" :label="item.empId" :key="item.empId">{{item.empName}}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
                <div class="left_module textTip" v-if="dataNull === true">
                    没有匹配的数据
                </div>
                <div class="right_module">
                    <el-checkbox-group v-model="checkedCities" @change="handleCitiesChange">
                        <el-checkbox v-for="item in checkedList" :label="item.empId" :key="item.empId">{{item.empName}}
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogChecked = false">取 消</el-button>
                <el-button type="primary" @click="confirmNext">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import ybPagination from 'components/ybPagination';
    import * as storage from '../../utils/sessionStorage'

    export default {
        components: {
            ybPagination
        },
        name: "inspectList",
        data() {
            return {
                queryLimit: {
                    current: 1,
                    keyword: '',
                    searchMonth: '',
                    size: 10
                },
                healthProblem: '',
                hygieneProblem: '',
                health: [
                    {
                        label: '发热',
                        value: '发热'
                    },
                    {
                        label: '感冒咳嗽',
                        value: '感冒咳嗽'
                    },
                    {
                        label: '外伤',
                        value: '外伤'
                    },
                    {
                        label: '呕吐腹泻',
                        value: '呕吐腹泻'
                    },
                    {
                        label: '皮肤疾病',
                        value: '皮肤疾病'
                    },
                    {
                        label: '其它疾病',
                        value: '其它疾病'
                    },
                ],
                hygiene: [
                    {
                        label: '着装不规范',
                        value: '着装不规范'
                    },
                    {
                        label: '双手不干净',
                        value: '双手不干净'
                    },
                    {
                        label: '指甲过长',
                        value: '指甲过长'
                    },
                    {
                        label: '戒指等饰品',
                        value: '戒指等饰品'
                    },
                    {
                        label: '其它卫生问题',
                        value: '其它卫生问题'
                    },

                ],
                tableData: [
                    {
                        date: "2016-05-03 09:00:00",
                        name: "就觉得决定,的开导开导看,发发发,发发发",
                        address: "上海市普陀区金沙江路 1518 弄",
                        inspector: '就觉得决定,的开导开导看,发发发,发发发',
                        remark: '这是备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注啊'
                    },
                    {
                        date: "2016-05-02 09:00:00",
                        name: "就觉得决定,的开导开导看,发发发,发发发",
                        address: "上海市普陀区金沙江路 1518 弄",
                        inspector: '就觉得决定,的开导开导看,发发发,发发发',
                        remark: '这是备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注啊'
                    },
                    {
                        date: "2016-05-04 09:00:00",
                        name: "就觉得决定,的开导开导看,发发发,发发发",
                        address: "上海市普陀区金沙江路 1518 弄",
                        inspector: '就觉得决定,的开导开导看,发发发,发发发',
                        remark: '这是备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注啊'
                    },
                    {
                        date: "2016-05-01 09:00:00",
                        name: "就觉得决定,的开导开导看,发发发,发发发",
                        address: "上海市普陀区金沙江路 1518 弄",
                        inspector: '就觉得决定,的开导开导看,发发发,发发发',
                        remark: '这是备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注啊'
                    },
                    {
                        date: "2016-05-08 09:00:00",
                        name: "王小虎",
                        address: "上海市普陀区金沙江路 1518 弄",
                        inspector: '就觉得决定,的开导开导看,发发发,发发发',
                        remark: '这是备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注啊'
                    },
                    {
                        date: "2016-05-06 09:00:00",
                        name: "王小虎",
                        address: "上海市普陀区金沙江路 1518 弄",
                        inspector: '就觉得决定,的开导开导看,发发发,发发发',
                        remark: '这是备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注啊'
                    },
                    {
                        date: "2016-05-07 09:00:00",
                        name: "王小虎",
                        address: "上海市普陀区金沙江路 1518 弄",
                        inspector: '就觉得决定,的开导开导看,发发发,发发发',
                        remark: '这是备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注备注啊'
                    }
                ],
                multipleSelection: [],
                page: {
                    pageSize: 10,
                    pageNum: 1,
                    total: 0
                },
                dialogChecked: false,
                searchWd: {
                    keyword: ''
                },
                unit: '人',
                title: '已选择人员',
                checkAll: false,
                checkedCities: ['222', '232'],
                cities: [
                    {
                        empId: '222',
                        empName: '十个人',
                        empPost: '人啊'
                    },
                    {
                        empId: '232',
                        empName: '是个人',
                        empPost: '了啊'
                    },
                    {
                        empId: '282',
                        empName: '发发人',
                        empPost: '人啊'
                    },
                    {
                        empId: '292',
                        empName: '是额个人',
                        empPost: '了啊'
                    },
                    {
                        empId: '3455',
                        empName: '咯额人',
                        empPost: '鹅鹅鹅'
                    },
                    {
                        empId: '3433335',
                        empName: '咯发发人',
                        empPost: '仍然'
                    }
                ],
                isIndeterminate: true,
                dataNull: false,
                checkedList: [
                    {
                        empId: '222',
                        empName: '十个人',
                        empPost: '人啊'
                    },
                    {
                        empId: '232',
                        empName: '是个人',
                        empPost: '了啊'
                    }
                ],
                citiesCopy: []
            }
        },
        methods: {
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            pageCurrentChange(num) {
                if (num !== this.page.pageNum) {
                    this.page.pageNum = num;
                }
            },
            pageSizeChange(size) {
                if (size !== this.page.pageSize) {
                    this.page.pageSize = size;
                }
            },
            delData() {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {
                    });
            },
            handleCheckAllChange() {
                this.checkAll = !!this.checkAll;
                let checked = this.cities.map(function (item) {
                    return item.empId;
                });
                this.checkedCities = this.checkAll ? checked : [];
                this.checkedList = this.checkAll ? JSON.parse(JSON.stringify(this.cities)) : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value) {
                let checkedCount = value.length;
                this.checkedList = []
                this.checkedCities.map(item => {
                    this.citiesCopy.map(items => {
                        if (items.empId == item) {
                            this.checkedList.push(items)
                        }
                    })
                })
                this.checkAll = checkedCount === this.cities.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;

            },
            handleCitiesChange() {
                this.checkedList = []
                this.checkedCities.map(item => {
                    this.cities.map(items => {
                        if (items.empId == item) {
                            this.checkedList.push(items)
                        }
                    })
                })
            },
            search() {
                this.cities.map(item => {
                    if (item.empName == this.queryLimit.keyword) {
                        this.cities = [item]
                        this.dataNull = false;
                    } else if (this.queryLimit.keyword == '') {
                        this.cities = JSON.parse(JSON.stringify(this.citiesCopy));
                        this.dataNull = false;
                    }
                })
            },
            getData() {
                this.citiesCopy = JSON.parse(JSON.stringify(this.cities))
            },
             confirmNext() {
                let result = [];
                this.checkedCities.map(item =>{
                    this.citiesCopy.map(items =>{
                        if(item == items.empId){
                            result.push(items)
                        }
                    })
                })
                storage.setData('inspectedPerson',JSON.stringify(result));
                this.dialogChecked = false;
                 this.$router.push('/kitchenManage/inspect/add');
            }
        },
        mounted() {
            this.getData()
        }
    }
</script>
<style>
    .el-dialog__body {
        padding: 0;
    }
</style>

<style scoped lang="scss">
    .line {
        width: 100%;
        height: 1px;
        background: #eeeeee;
    }

    .el-checkbox {
        width: 80px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-right: 25px;
    }

    .wrap {
        width: calc(100% - 40px);
        padding: 0 20px;
        height: 100%;
        background: #f6f6f6;
        .title {
            height: 60px;
            line-height: 60px;
            .title_left {
                font-size: 20px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                width: 50%;
                height: 100%;
            }
        }
        .innerBox {
            width: calc(100% - 60px);
            padding: 20px 30px;
            height: calc(100% - 125px);
            background: #fff;
            border-radius: 10px;
            overflow: scroll;
            .operate {
                .left {
                    float: left;
                }
                .right {
                    float: right;
                }
            }
        }
        .module {
            background: #fff;
            width: 720px;
            height: 400px;
            margin: 0;
            padding: 0;
            .header {
                width: 100%;
                height: 60px;
                .left_header {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 358px;
                    height: 100%;
                    border-right: 1px solid #eeeeee;
                    box-sizing: border-box;
                }
                .right_header {
                    width: 358px;
                    height: 100%;
                    .title {
                        float: left;
                        font-size: 16px;
                        color: #333333;
                        line-height: 22px;
                        margin: 19px 0 0 30px;
                        display: inline-block;
                    }
                    .statistic {
                        font-size: 14px;
                        color: #999999;
                        line-height: 20px;
                        margin-top: 19px;
                        float: right;
                        display: inline-block;
                    }
                }
            }
            .textTip {
                text-align: center;
            }
            .left_module {
                width: 358px;
                height: 340px;
                display: inline-block;
                border-top: 1px solid #eeeeee;
                border-bottom: 1px solid #eeeeee;
                border-right: 1px solid #eeeeee;
                box-sizing: border-box;
                padding: 20px;
                overflow: scroll;
            }
            .right_module {
                width: 358px;
                height: 340px;
                display: inline-block;
                border-top: 1px solid #eeeeee;
                border-bottom: 1px solid #eeeeee;
                box-sizing: border-box;
                padding: 20px;
                overflow: scroll;
            }
        }
    }
</style>